var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.receiptTemplate && _vm.receipts)?_c('Receipt',{attrs:{"receipt-template":_vm.receiptTemplate,"receipts":_vm.receipts,"template":2,"print-header":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }